import {collection, EntityData, field, identifier, SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

export enum ItemAvailability {
    AVAILABLE = <any>"available",
    SOLD_OUT_TODAY = <any>"soldOutToday",
    SOLD_OUT = <any>"soldOut",
    NOT_SOLD = <any>"notSold"
}

export class ItemAvailabilityData extends EntityData<ItemAvailabilityData> {
    @identifier sellableId: number;
    @field name: string;
    @field productCountdownId: string;
    @field locationId: number;
    @field productCount: number;
    @field resetAtStartOfDay: boolean;
    @field restockLevel: number;
    @field soldOutToday: boolean;
    @field notSold: boolean;
    @field categoryNames: string;
    @field touchItemNames: string;
    @field menuNames: string;
    @field pinned: boolean;
}

@Injectable()
export class AppItemAvailabilitySearchModel extends SearchModel<ItemAvailabilityData> {
    constructor(injector: Injector) {
        super(injector, ItemAvailabilityData);
    }

    override getIdentifierField(): string {
        return "sellableId";
    }

    override getResource(): string {
        return "web-ordering-item-availability";
    }
}
